import { render, staticRenderFns } from "./SingleProject.vue?vue&type=template&id=7fa539c2&scoped=true&"
import script from "./SingleProject.vue?vue&type=script&lang=js&"
export * from "./SingleProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa539c2",
  null
  
)

export default component.exports